import { API_FEEDBACK_SUBJECT_PREFIX } from '@shared/config/api/api-prefixes';
import { feedbackSubjectBaseApi } from './base';
import {
    FeedbackSubjectDetailDataRequest,
    FeedbackSubjectDetailDataResponse,
    FeedbackSubjectListDataRequest,
    FeedbackSubjectListDataResponse,
    UpdateFeedbackSubjectDataResponse,
    UpdateFeedbackSubjectDataRequest,
    CreateFeedbackSubjectDataResponse,
    CreateFeedbackSubjectDataRequest,
} from './feedback-subject-types';
import { queryParametersToString } from '@shared/lib/utils/query-parameters-to-string/query-parameters-to-string';

export const feedbackSubjectApi = feedbackSubjectBaseApi.injectEndpoints({
    endpoints: (build) => ({
        feedbackSubjectsList: build.query<FeedbackSubjectListDataResponse, FeedbackSubjectListDataRequest>({
            query: (parameters) => `${API_FEEDBACK_SUBJECT_PREFIX}${queryParametersToString({ ...parameters })}`,
            providesTags: ['FeedbackSubjectsList'],
        }),
        feedbackSubjectDetail: build.query<FeedbackSubjectDetailDataResponse, FeedbackSubjectDetailDataRequest>({
            query: (id) => `${API_FEEDBACK_SUBJECT_PREFIX}/${id}/detail`,
        }),
        updateFeedbackSubject: build.mutation<UpdateFeedbackSubjectDataResponse, UpdateFeedbackSubjectDataRequest>({
            query: (data) => {
                return {
                    url: `${API_FEEDBACK_SUBJECT_PREFIX}/${data.id}`,
                    method: 'PATCH',
                    body: data,
                };
            },
            invalidatesTags: ['FeedbackSubjectsList'],
        }),
        createFeedbackSubject: build.mutation<CreateFeedbackSubjectDataResponse, CreateFeedbackSubjectDataRequest>({
            query: (data) => {
                return {
                    url: API_FEEDBACK_SUBJECT_PREFIX,
                    method: 'POST',
                    body: data,
                };
            },
            invalidatesTags: ['FeedbackSubjectsList'],
        }),
    }),
});

export const {
    useLazyFeedbackSubjectsListQuery,
    useLazyFeedbackSubjectDetailQuery,
    useUpdateFeedbackSubjectMutation,
    useCreateFeedbackSubjectMutation,
    usePrefetch: usePrefetchFeedbackSubject,
} = feedbackSubjectApi;
